import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { voucherService } from "Services/Axios/voucherService";

export const getVoucher = createAsyncThunk(
    'voucher/getVoucher',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await voucherService.getVoucher(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitVoucher = createAsyncThunk(
    'voucher/submitVoucher',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('code', data.code);
            formData.append('discount', data.discount);
            formData.append('quota', data.quota);
            formData.append('type', data.type); // 1: percentage, 2: nominal
            formData.append('expired_at', data.expired_at);
            formData.append('is_public', data.is_public);
            data.banner && formData.append('banner', data.banner);

            let response;
            if (data.id) {
                response = await voucherService.updateVoucher(data.id, formData);
            } else {
                response = await voucherService.createVoucher(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteVoucher = createAsyncThunk(
    'voucher/deleteVoucher',
    async (id, { rejectWithValue }) => {
        try {
            const response = await voucherService.deleteVoucher(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

